import { Injectable } from '@angular/core';
import { LocalDbService } from '../local-db-service';
import { Motive } from '../../entities/motive';

@Injectable({ providedIn: 'root' })
export class MotiveRepository {
  private get table() {
    return this.db.motivesTable;
  }

  constructor(private readonly db: LocalDbService) {}

  async getAll(): Promise<Motive[]> {
    const rows = await this.table.toArray();
    return rows.map(row => Object.assign(new Motive(row), row));
  }

  async getById(id: number): Promise<Motive | undefined> {
    const row = await this.table.get(id);
    return row ? Object.assign(new Motive(row), row) : undefined;
  }

  upsert(motive: Motive): Promise<number> {
    return this.table.put(motive);
  }

  upsertBulk(motives: Motive[]): Promise<number> {
    return this.table.bulkPut(motives);
  }

  delete(id: number): Promise<void> {
    return this.table.delete(id);
  }

  clear(): Promise<void> {
    return this.table.clear();
  }
}